import React from 'react'
import { Button, Col, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import FormatNumbers from '../../utils/formatNumbers';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import { DialogPreviewComplementPayment } from './DialogPreviewComplementPayment';
import { Dialog } from 'primereact/dialog';


export const ModalComplementPayment = (props) => {

	const {
		loadingPreview, showPreviewInvoice, handlePreviewInvoice, listInvoices, handleChangeAmount, handleChangeType, clientInformation,
		formComplement, setFormComplement, listPayForms, listCommercialLines, handleSaveComplement, disbleButton, datECurrentTime, setDatECurrentTime, showPreview,
		setShowPreview, serie,
	} = props;
	console.log("🚀 ~ ModalComplementPayment ~ formComplement:", formComplement)
	console.log("🚀 ~ ModalComplementPayment ~ serie:", serie)


	const totalSaldo = listInvoices.reduce((total, invoice) => total + (invoice?.outside_balance ?? 0), 0);


	const [createSweet] = useSweetAlert();

	return (
		<>
			<Dialog
				header="Genarar complemento"
				visible={showPreviewInvoice}
				style={{ width: '60vw', maxWidth: '500px' }}
				modal
				dismissableMask
				onHide={handlePreviewInvoice}
				className="large-dialog-paymentI"
				footer={
					<Col className={loadingPreview ? "d-none" : ""} >
						<div>
							<Button color='success' size='sm' disabled={disbleButton} onClick={() => setShowPreview(true)}>Previsualizar</Button>


							<Button color='secondary' size='sm' disabled={disbleButton} onClick={handleSaveComplement}>Crear complemento</Button>

						</div>
					</Col>
				}
			>

				<>
					{
						loadingPreview && (
							<>
								<Row>
									<Col sm="12" md="12" lg="12" className='text-center'>
										<img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "20%" }} />
									</Col>
									<Col sm="12" md="12" lg="12" className='text-center mt-1'>
										<p>Cargando ...</p>
									</Col>
								</Row>
							</>
						)
					}



					{
						!loadingPreview && (
							<div className="complement-container pt-3">

								{/* HEADER NUEVO */}
								<div className="complement-header-card">
									<div className="complement-header-left">

										<div className="complement-header-icon">
											<i className="pi pi-file-pdf"></i>
										</div>

										<div>
											<div className="complement-header-title">
												CONFIGURACIÓN DEL ENCABEZADO
											</div>
											<div className="complement-header-sub">
												Encabezador del documento
											</div>
										</div>

									</div>
								</div>

								{/* ===== PASOS ===== */}
								<div className="complement-card pl-4">

									{/* STEP 1 */}
									<div className="step-row">
										<div className="step-circle bg-dark">1</div>

										<div className="step-body">
											<div className="step-title">Emisor</div>

											<Input
												type="select"
												size="sm"
												className="complement-input"
												value={formComplement?.commercialLineId ?? ''}
												onChange={(e) => {
													setFormComplement({
														...formComplement,
														commercialLineId: e.target.value,
													})
												}}
											>
												<option value=''>Selecciona una opción</option>
												{listCommercialLines?.map((company, index) => (
													<option key={index} value={company.value}>{company.label}</option>
												))}
											</Input>
										</div>
									</div>

									{/* STEP 2 */}
									<div className="step-row">
										<div className="step-circle bg-success">2</div>

										<div className="step-body">
											<div className="step-title">Receptor</div>

											<Input
												type="select"
												size="sm"
												className="complement-input"
												value={formComplement?.companyBusinessNameId ?? ''}
												onChange={(e) => {
													setFormComplement({
														...formComplement,
														companyBusinessNameId: e.target.value,
														taxRegimeId: clientInformation?.listCompanyBusinessNames?.find(c => c.id_company_business_name === e.target.value)?.id_tax_regime ?? '',
														type_person: clientInformation?.listCompanyBusinessNames?.find(c => c.id_company_business_name === e.target.value)?.type_person ?? '',
													})
												}}
											>
												<option value=''>Selecciona una opción</option>
												{clientInformation?.listCompanyBusinessNames?.map((c, i) => (
													<option key={i} value={c.id_company_business_name}>{c.business_name}</option>
												))}
											</Input>
										</div>
									</div>

									{/* STEP 3 */}
									<div className="step-row">
										<div className="step-circle bg-warning">3</div>

										<div className="step-body">
											<div className="step-title">Fecha de pago</div>

											<Input
												type="date"
												size="sm"
												className="complement-input"
												value={formComplement.paymentDate}
												onChange={(e) => {
													setFormComplement({
														...formComplement,
														paymentDate: e.target.value
													})
												}}
											/>
										</div>
									</div>

									{/* STEP 4 */}
									<div className="step-row">
										<div className="step-circle bg-secondary">4</div>

										<div className="step-body">
											<div className="step-title">Forma de pago / Comentarios</div>

											<Row>
												<Col md="6">
													<Input
														type="select"
														size="sm"
														className="complement-input"
														value={formComplement.paymentFormId}
														onChange={(e) => {
															setFormComplement({
																...formComplement,
																paymentFormId: e.target.value
															})
														}}
													>
														<option value=''>Selecciona una opción</option>
														{listPayForms.map((p, i) => (
															<option key={i} value={p.code}>{p.label}</option>
														))}
													</Input>
												</Col>

												<Col md="6">
													<Input
														type="text"
														size="sm"
														className="complement-input"
														value={formComplement.comments}
														onChange={(e) => {
															setFormComplement({
																...formComplement,
																comments: e.target.value
															})
														}}
													/>
												</Col>
											</Row>
										</div>
									</div>

								</div>


								<div className="complement-header-card">
									<div className="complement-header-left">

										<div className="complement-header-icon-2">
											<i className="pi pi-wallet"></i>
										</div>

										<div>
											<div className="complement-header-title">
												CONFIGURACIÓN DEL PAGO
											</div>
											<div className="complement-header-sub">
												Importes cobrados en las facturas
											</div>
										</div>

									</div>
								</div>

								{/* ===== TABLA (NO SE TOCA) ===== */}
								{/* <Col sm="12" md="12" lg="12">
									{listInvoices.map((invoice, index) => (
										<Row key={index} className="b-b-1 b-light">
											<Col sm="12" md="2" lg="3" className="pt-1">
												<Button
													color={invoice?.paymentBy === "amount" ? "light" : "dark"}
													size="sm"
													onClick={() => {
														handleChangeType(invoice?.paymentBy === "amount" ? "liquided" : "amount", invoice?.id_invoice);
													}}
												>
													{invoice?.paymentBy === "liquided" ? "* Por monto" : "Liquidar"}
												</Button>
											</Col>
											<Col sm="12" md="2" lg="2" className="text-center m-0">
												<p className="m-0 f-w-600">Serie/Folio</p>
												<p className="m-0">{invoice?.serie ?? ""} {invoice?.folio ?? ""}</p>
											</Col>
											<Col sm="12" md="2" lg="2" className="text-center">
												<p className="m-0 f-w-600">Total</p>
												<p className="m-0">${FormatNumbers(invoice?.total ?? 0, 2)}</p>
											</Col>
											<Col sm="12" md="2" lg="2" className="text-center">
												<p className="m-0 f-w-600">Saldo</p>
												<p className="m-0">{FormatNumbers(invoice?.outside_balance ?? 0, 2)}</p>
											</Col>
											<Col sm="12" md="2" lg="3" className="pt-1">
												<Input
													type="number"
													disabled={invoice?.paymentBy === "liquided" ? true : false}
													size={"sm"}
													className="form-control form-control-sm input-air-primary"
													value={invoice?.paymentBy === "liquided" ? invoice?.outside_balance ?? 0 : invoice?.amount}
													onChange={(e) => {
														if (e.target.value !== "") {
															if (isNaN(+parseFloat(e.target.value))) return;
															if (parseFloat(e.target.value) <= 0 || parseFloat(e.target.value) > invoice?.outside_balance) {
																createSweet("warning", "warning", "Ingrese una cantidad inferior o igual al saldo");
																return;
															}
														}
														handleChangeAmount(e.target.value, invoice?.id_invoice);
													}}
													invalid={invoice?.paymentBy === "liquided" ? false : invoice.amount === "" || invoice.amount === "0" || invoice.amount === 0}
												/>
												<FormFeedback>El monto debe ser mayor a cero</FormFeedback>
											</Col>
										</Row>
									))}

									<Row className="text-center mt-2">
										<Col sm="12" md="2" lg="2" className="offset-lg-7">
											<div style={{ backgroundColor: "black", color: "white", padding: "5px 10px", fontSize: "16px" }}>
												<p className="m-0">${FormatNumbers(totalSaldo, 2)}</p>
											</div>
										</Col>
									</Row>
								</Col> */}
								<Col sm="12" md="12" lg="12" className="invoice-container">

									{listInvoices.map((invoice, index) => {
										return <div key={index} className="invoice-card-row">

											{/* BOTÓN */}
											<div className="invoice-col action">
												<Button
													size="sm"
													className={`invoice-btn ${invoice?.paymentBy === "liquided" ? "active" : ""}`}
													onClick={() => {
														handleChangeType(
															invoice?.paymentBy === "amount" ? "liquided" : "amount",
															invoice?.id_invoice
														);
													}}
												>
													{invoice?.paymentBy === "liquided" ? "* Por monto" : "Liquidar"}
												</Button>
											</div>

											{/* SERIE */}
											<div className="invoice-col text-center">
												<span className="invoice-label">Serie/Folio</span>
												<p>{invoice?.serie ?? ""} {invoice?.folio ?? ""}</p>
											</div>

											{/* TOTAL */}
											<div className="invoice-col text-center">
												<span className="invoice-label">Total</span>
												<p>${FormatNumbers(invoice?.total ?? 0, 2)}</p>
											</div>

											{/* SALDO */}
											<div className="invoice-col text-center">
												<span className="invoice-label">Saldo</span>
												<p>${FormatNumbers(invoice?.outside_balance ?? 0, 2)}</p>
											</div>

											{/* INPUT */}
											<div className="invoice-col">
												<Input
													type="number"
													size="sm"
													className="invoice-input"
													disabled={invoice?.paymentBy === "liquided"}
													value={
														invoice?.paymentBy === "liquided"
															? invoice?.outside_balance ?? 0
															: invoice?.amount
													}
													onChange={(e) => {
														if (e.target.value !== "") {
															if (isNaN(+parseFloat(e.target.value))) return;
															if (
																parseFloat(e.target.value) <= 0 ||
																parseFloat(e.target.value) > invoice?.outside_balance
															) {
																createSweet("warning", "warning", "Ingrese una cantidad válida");
																return;
															}
														}
														handleChangeAmount(e.target.value, invoice?.id_invoice);
													}}
												/>
												<FormFeedback>El monto debe ser mayor a cero</FormFeedback>
											</div>

										</div>;
									})}

									{/* TOTAL */}
									<div className="invoice-total-container">
										<div className="invoice-total-box">
											<span className="invoice-total-label">Total</span>
											<span className="invoice-total-amount">
												${FormatNumbers(totalSaldo, 2)}
											</span>
										</div>
									</div>

								</Col>


							</div>
						)
					}
				</>

			</Dialog>

			<DialogPreviewComplementPayment
				{...{
					showPreview, setShowPreview, formComplement, listCommercialLines, clientInformation, listInvoices, datECurrentTime,
					setDatECurrentTime, serie
				}}
			/>

		</>


	)
}
